
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[collectionSlug]",
      function () {
        return require("private-next-pages/collections/[collectionSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/[collectionSlug]"])
      });
    }
  